<template>
  <b-container
    fluid
    class="bg-white"
    style="min-height: calc(100vh - 95px); max-height: calc(100vh - 95px); overflow-y: auto"
    data-cy="return-confirmation-main-container"
  >
    <b-container data-cy="return-confirmation-content-container">
      <b-col
        cols="12"
        class="p-4 p-md-5 bg-white"
        data-cy="return-confirmation-header-col"
      >
        <div class="d-flex flex-column" data-cy="return-confirmation-header">
          <h4
            class="text-primary font-weight-bold"
            data-cy="return-confirmation-title"
          >
            Confira os dados do seu retorno
          </h4>
          <small class="font-weight-bold" data-cy="return-confirmation-subtitle"
            >Confira se todos os dados do retorno estão corretos e
            confirme</small
          >
        </div>

        <table
          class="table table-responsive h6 mt-3"
          data-cy="return-confirmation-table"
        >
          <tbody>
            <tr data-cy="return-confirmation-row-paciente">
              <td data-cy="return-confirmation-label-paciente">Paciente</td>
              <td
                class="font-weight-bold text-primary"
                data-cy="return-confirmation-value-paciente"
              >
                {{ selectedReturn.usuarioPortal.nome }}
              </td>
            </tr>
            <tr data-cy="return-confirmation-row-clinica">
              <td data-cy="return-confirmation-label-clinica">Clinica</td>
              <td
                class="font-weight-bold text-primary"
                data-cy="return-confirmation-value-clinica"
              >
                {{ selectedReturn.clinica.nome }}
              </td>
            </tr>
            <tr data-cy="return-confirmation-row-especialidade">
              <td data-cy="return-confirmation-label-especialidade">
                {{ type === "exame" ? "Procedimento" : "Especialidade" }}
              </td>
              <td
                class="font-weight-bold text-primary"
                data-cy="return-confirmation-value-especialidade"
              >
                {{ selectedReturn.especialidade.nome }}
              </td>
            </tr>
            <tr data-cy="return-confirmation-row-profissional">
              <td data-cy="return-confirmation-label-profissional">
                Profissional
              </td>
              <td
                class="font-weight-bold text-primary"
                data-cy="return-confirmation-value-profissional"
              >
                {{ formattedProfissionalName }}
              </td>
            </tr>
            <tr data-cy="return-confirmation-row-datahora">
              <td data-cy="return-confirmation-label-datahora">Data e Hora</td>
              <td
                class="font-weight-bold text-primary"
                data-cy="return-confirmation-value-datahora"
              >
                {{ dataSelected }}
              </td>
            </tr>

            <tr data-cy="return-confirmation-row-convenio">
              <td data-cy="return-confirmation-label-convenio">Convênio</td>
              <td
                class="font-weight-bold text-primary"
                data-cy="return-confirmation-value-convenio"
              >
                {{ selectedReturn.convenio.nome }}
              </td>
            </tr>
            <tr data-cy="return-confirmation-row-localizacao">
              <td data-cy="return-confirmation-label-localizacao">
                Localização
              </td>
              <td
                class="font-weight-bold text-primary"
                data-cy="return-confirmation-value-localizacao"
              >
                {{ selectedReturn.clinica | clinicAddress }}
              </td>
            </tr>
            <tr v-show="false" data-cy="return-confirmation-row-mapa">
              <td colspan="2" class="px-0">
                <img
                  style="background-image: url('/static/images/google-map-placeholder.png'); background-size: cover; background-position: center;"
                  class="w-100"
                  height="300"
                  data-cy="return-confirmation-img-mapa"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </b-col>
      <b-row data-cy="return-confirmation-actions-row">
        <b-col class="bg-white" data-cy="return-confirmation-actions-col">
          <hr class="w-100 my-5" data-cy="return-confirmation-actions-hr" />
          <div
            id="workflow-buttons-wrapper"
            class="d-flex justify-content-between"
            data-cy="return-confirmation-actions-btn-wrapper"
          >
            <router-link
              :to="{
                name: 'return',
                params: { organizationId: $route.params.organizationId }
              }"
              class="btn btn-outline-primary btn-lg rounded-0 d-flex justify-content-center align-items-center flex-grow-1 flex-md-grow-0"
              data-cy="return-confirmation-btn-voltar"
              >Voltar e ajustar</router-link
            >

            <b-button
              @click="submit"
              variant="primary"
              class="btn btn-primary btn-lg rounded-0 d-flex justify-content-center align-items-center flex-grow-1 flex-md-grow-0"
              data-cy="return-confirmation-btn-confirmar"
              >Confirmar</b-button
            >
          </div>
        </b-col>
      </b-row>
    </b-container>
  </b-container>
</template>

<script>
import { axiosInstance as Axios } from "@/main";

export default {
  computed: {
    selectedReturn() {
      return this.$store.getters.selected_return;
    },
    dataSelected() {
      return this.$store.getters.get_selected[3].nome;
    },
    formattedProfissionalName() {
      const selected = this.$store.getters.get_selected[3];
      const profissional = selected.medics[0];
      return profissional.tratamento
        ? `${profissional.tratamento} ${profissional.nome}`
        : profissional.nome;
    }
  },
  methods: {
    async submit() {
      try {
        await Axios.post(
          `${this.$serverHost}protected/me/agendamentos/${this.selectedReturn.id}/retorno`,
          {
            agendaId: this.$store.getters.get_selected[3].medics[0].agendas[0]
              .id,
            horaAgendamento: this.$store.getters.get_selected[3].date
          },
          {
            headers: {
              "X-Organizacao-ID": this.$route.params.organizationId,
              Authorization: `Bearer ${this.$store.getters.token}`
            }
          }
        );

        this.$router.push({
          name: "return",
          params: { organizationId: this.$route.params.organizationId }
        });
      } catch (e) {
        console.log(e);

        return;
      }
    }
  }
};
</script>

<style></style>
